import { render, staticRenderFns } from "./string-list.vue?vue&type=template&id=a71a7be2&scoped=true&"
import script from "./string-list.vue?vue&type=script&lang=ts&"
export * from "./string-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71a7be2",
  null
  
)

export default component.exports